const autocompleteFromCreateUser = {
  site: 'Sitios',
  companies: 'Tercera empresa'
};

export default autocompleteFromCreateUser;
